module.exports = __webpack_public_path__ + "static/vision2030-logo-2a9b15153f778324e81cd9307a205376.png";